import React, { memo, useState } from "react";

export default memo(props => {
  const { textA, defaultData, setData, setAfMealTime } = props;

  const [viewText, setViewText] = useState(defaultData);
  const [toggleOn, setToggleOn] = useState(false);

  return (
    <div style={props.style}>
      <div className={`select-custom-box bfaf-select ${toggleOn ? "on" : ""}`}>
        <a
          className="btn-select"
          id={props.id}
          onClick={e => {
            setToggleOn(!toggleOn);
          }}>
          {viewText}
        </a>
        <ul style={{ maxHeight: "200px", overflow: "auto" }}>
          {textA.map((m, i) => (
            <li key={i}>
              <a
                onClick={e => {
                  setToggleOn(!toggleOn);
                  setViewText(m);
                  setData(m == "식전" ? "B" : "A");
                  setAfMealTime(m == "식전" ? null : "0200");
                }}>
                {m}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
});
